import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'src/lib/router/with_router'
import { ListGroup, Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ChatList from './chat_list'
import { logout } from 'src/store/login'
import { Trans } from 'react-i18next'
import ResetPasswordModal from 'src/components/users/reset_password_modal'
import Notification from 'src/components/layout/navbar/nav_right/notification'

const mstp = state => {
  let {
    id,
    username,
    email,
    first_name,
    last_name,
    is_management_account,
    business_role_name,
    business_role_priority,
  } = state.userInfo
  let { messages } = state.messages
  let name = `${first_name} ${last_name}`
  if (is_management_account) {
    name = username
    business_role_name = <Trans i18nKey="roles.management_account">Account di servizio</Trans>
  }
  return { username, name, email, id, business_role_name, messages, business_role_priority }
}

class NavRight extends Component {
  resetModalRef = React.createRef()
  state = {
    listOpen: false,
    time_id: null,
  }

  toggleChatbox = () => {
    this.setState({ listOpen: !this.state.listOpen })
  }

  logout = async () => {
    await this.props.dispatch(logout())
    this.props.router.navigate('/login', { replace: true })
  }

  toggleResetPasswordModal = () => {
    this.resetModalRef.current.toggle()
  }

  render() {
    let { name, business_role_name, messages, business_role_priority } = this.props
    let avatar_link = `https://ui-avatars.com/api/?name=${name}&background=cf463e&color=fff`
    let has_new_messages = messages.filter(m => m.read_at === null).length
    return (
      <React.Fragment>
        <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
          <ListGroup.Item as="li" bsPrefix=" ">
            {business_role_priority > 1 && (
              <Notification
                messages={messages}
                has_new_messages={has_new_messages}
                dispatch={this.props.dispatch}
                router={this.props.router}
              />
            )}
          </ListGroup.Item>
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown align={'end'} className="drp-user d-flex align-items-center flex-row">
              <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                <img
                  width="40"
                  src={avatar_link}
                  className="img-radius"
                  alt={<Trans i18nKey="system_wide.navbar.avatar">Foto profilo</Trans>}
                />
              </Dropdown.Toggle>
              <Dropdown.Menu align="end" className="profile-notification">
                <div className="pro-head d-flex flex-row">
                  <img
                    src={avatar_link}
                    className="img-radius"
                    alt={<Trans i18nKey="system_wide.navbar.avatar">Foto profilo</Trans>}
                  />
                  <div>
                    <span>{name}</span>
                    <br />
                    <span>
                      <b>{business_role_name}</b>
                    </span>
                  </div>

                  <i role="button" onClick={this.logout} className="dud-logout feather icon-log-out" />
                </div>
                <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link role="button" onClick={this.toggleResetPasswordModal} className="dropdown-item">
                      <i className="feather icon-lock" />
                      <Trans i18nKey="system_wide.navbar.change_password">Modifica password</Trans>
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown>
          </ListGroup.Item>
        </ListGroup>
        <ChatList listOpen={this.state.listOpen} closed={this.toggleChatbox} />
        <ResetPasswordModal ref={this.resetModalRef} username={this.props.username} mountedOnUserForm={false} />
      </React.Fragment>
    )
  }
}

export default connect(mstp)(withRouter(NavRight))
